import { useQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';
import { IWorkTime } from '../interface/workTimes';

interface IFetchWorkTimeDetail {
  id?: string;
  relations?: string[];
  fields?: string[];
}
export const useFetchWorkTimeDetail = (params: IFetchWorkTimeDetail) => {
  const { id, ...queryParams } = params;
  const queryString = Object.keys(queryParams)?.length
    ? toQueryString(queryParams as QueryParamObject)
    : null;
  const workTimeDetailUrl = `${API_URLS.WORK_TIMES}/${id}`;
  const url = queryString ? `${workTimeDetailUrl}?${queryString}` : workTimeDetailUrl;
  const query = useQuery<IWorkTime, Error>({
    queryKey: ['work-time-details', id],
    queryFn: async () => {
      const response = await get(url);
      return response;
    },
    enabled: !!id,
  });

  return query;
};
